module.exports = __webpack_public_path__ + "img/ci_2.2888c28e.png";